/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef } from "react";
import { useGLTF, useAnimations, useVideoTexture } from "@react-three/drei";
import * as THREE from "three";

export function Ark(props) {
  const group = useRef();
  const {scene, nodes, materials, animations } = useGLTF("/ark.glb");
  const { actions ,names} = useAnimations(animations,scene)

  

  const texture = useVideoTexture('Space.mp4')


  useEffect(() => {

    texture.anisotropy = 10

    actions[names[0]].reset().play()
    actions[names[1]].reset().play()
  
    materials['材质'].map = texture

    Object.values(materials).forEach((el, i) => {

     if(el.name !=='window.006' && el.name !== 'Black.006' && el.name !== '材质.019'){
      el.toneMapped = false;

     }

    });

    materials["Black.006"].color = new THREE.Color("black");
    materials["window.006"].color = new THREE.Color("black");
    materials["window.006"].roughness = 0.73;
    materials["Black.006"].roughness = 0.73;
    // materials["材质.019"].roughness = 0.38;
    materials["材质.005"].side = THREE.DoubleSide;
  }, [materials]);

  return (
    <primitive ref={group} object={nodes.Scene}/>
  );
}

useGLTF.preload("/ark.glb");
